// shadcn label https://ui.shadcn.com/docs/components/label
// Option A: native <label> (Base UI has no standalone Label; Field.Label deferred to WEB-302).

import { cva } from "class-variance-authority";
import type { VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils";

export const labelVariants = cva(
  "text-ds-body-md text-grey-800 font-semibold peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
);

const Label = React.forwardRef<
  HTMLLabelElement,
  React.ComponentPropsWithoutRef<"label"> & VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
  // Association is provided by callers via htmlFor or nested controls.
  // eslint-disable-next-line jsx-a11y/label-has-associated-control
  <label ref={ref} className={cn(labelVariants(), className)} {...props} />
));
Label.displayName = "Label";

export { Label };
